import { Data } from "effect"

export type ServerErrorData = {
  message: string
  traceId?: string
}

export namespace ServerErrorData {
  export const make = Data.case<ServerErrorData>()

  export const fromUnknown = (u: unknown): ServerErrorData | undefined => {
    if (typeof u !== "object" || u === null) {
      return undefined
    }
    if (!("message" in u) || typeof u.message !== "string") {
      return undefined
    }
    const traceId = "traceId" in u && typeof u.traceId === "string" ? u.traceId : undefined

    return make({ message: u.message, traceId })
  }
}
